export const FOOTER_CMS_CONTENT_KEY = 'layout.footer';
